

import React from 'react';
import { connect } from 'react-redux';
import { setIsUserLoggedInTrue, setUserRegisterDetails, setLoginPage } from '../../General/Actions.js';
import ValidateForm from '../../Utils/formValidation';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';
import BlueSkyWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import SignUpComponent from './SignUpComponent';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Background from '../../ImageAssets/blueskyBackground.png';
import { Input, Button } from 'reactstrap';
import { FaArrowLeft } from 'react-icons/fa';
import moment from 'moment';

class resetPasswordUsingLinkPartComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            passwordInResetPasswordPart: "",
            confirmPasswordInResetPasswordPart: "",
            newPasswordhidden: true,
            confirmPasswordhidden: true,
            isPasswordInfoTooltipOpen: false,
            isLinkExpired: false
        }
    }

    submitButtonClicked = () => {
        if (ValidateForm.inputFieldMandatoryCheck("changePasswordContainer", this.props.locales)) {
            if (ValidateForm.inputFieldValueCompositionCheck("changePasswordContainer", this.props.locales)) {
                if (this.state.passwordInResetPasswordPart === this.state.confirmPasswordInResetPasswordPart) {
                    this.setState({ isLoading: true })
                    var dataToSend = {
                        "userId": this.props.userDetails.userid,
                        "username": this.props.userDetails.username,
                        "password": this.state.passwordInResetPasswordPart
                    }
            
                    Network.executeAxios("passwordResetUsingLink", "POST", dataToSend, (response) => {
                        this.setState({ isLoading: false })
                        if (response.STATUS === "SUCCESS") {
                            Swal.fire(this.props.locales.ResetPasswordSwalSuccess, "", "");
                            setTimeout(() => {
                                window.location = "/"
                                this.props.setLoginPage("pageName", "login");
                            }, 3000);
                        }
                        else {
                            Swal.fire(this.props.locales.ResetPasswordSwal, "", "");
                        }
                    });

                } else {
                    Swal.fire(this.props.locales.ResetPasswordDoesNtMatchSwal, "", "");
                }
            }
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        var currentTime = moment(new Date());
        var createTime = parseInt(this.props.userDetails.resetPassCreateTime);
        var duration = moment.duration(currentTime.diff(createTime));
        var diffInMinutes = duration.asMinutes().toFixed();
        console.log("difference in minutes >> ", diffInMinutes);
        if (diffInMinutes > parseInt(this.props.locales.resetPassLinkExpiry)) {
            this.setState({ isLinkExpired: true })
            Swal.fire(this.props.locales.resetPassLinkExpiredText, "", "");
            setTimeout(() => {
                window.location = "/"
            }, 4000);
        }
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    displayLabel(event, value, placeHolderText) {
        if (value !== "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

    inputValueChange(name, value) {
        this.setState({ [name]: value })
    }
    arrowIconClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetPasswordSetPasswordOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetPasswordSetPasswordOuterMainContainerStyle}>
                <div className="row" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0 d-none d-sm-block" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {/* {this.resetPasswordLinkPartComponent()} */}
                            {this.state.isLinkExpired ? this.linkExpiredComponentContent() : this.resetPasswordLinkPartComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    linkExpiredComponentContent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0 pb-5">
                <div className="d-none d-sm-block d-md-none d-block col-md-12 p-0">
                    <div className="row col-md-12 m-auto py-4 px-2" style={{ backgroundColor: '#39b54a' }}>
                        <div className="col-md-12 ml-5"><FaArrowLeft color="#FFFFFF" size="30" onClick={() => this.arrowIconClicked()} style={{ paddingRight: 10 }} /> <img alt="" src={BlueSkyWhiteTextLogo} width="94" height="20" /></div>
                    </div>
                </div>
                <div className="col-md-12 row py-5 m-0 my-5 d-none d-sm-block">
                </div>
                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9 pl-5 pt-3 mt-3" id="changePasswordContainer">
                        <div className="col-md-12 pb-3" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.changePasswordSetYourPswTxt}</div>
                        <div className="form-group col-md-12 pb-3">
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.changePasswordEnterPswTxt}</label>
                            <Input type="password" name="passwordInResetPasswordPart" autoComplete="new-password" className="loginCredItem input_data mandatoryFieldSpecial typePassword pt-4 pb-3"
                                placeholder={this.props.locales.changePasswordNewPswPlc}
                                onKeyUp={(event) => this.displayLabel(event, this.state.passwordInResetPasswordPart, this.props.locales.changePasswordNewPswPlc)} style={{ color: '#404042', fontWeight: 500 }} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        <div className="form-group col-md-12" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.changePasswordConfirmPswTxt}</label>
                            <Input type="password" name="confirmPasswordInResetPasswordPart" autoComplete="new-password" className="loginCredItem input_data mandatoryFieldSpecial typePassword pt-4 pb-3"
                                placeholder={this.props.locales.changePasswordComfirmPswPlc}
                                onKeyUp={(event) => this.displayLabel(event, this.state.confirmPasswordInResetPasswordPart, this.props.locales.changePasswordComfirmPswPlc)} style={{ color: '#404042', fontWeight: 500 }} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        <div className="form-group col-md-12 pt-2">
                            {this.props.locales.SettingsCompCharecterToolTip}
                        </div>
                        <div className="col-md-12 pt-4">
                            <Button className="loginPageLoginButton">
                                {this.props.locales.changePasswordDoneBtn}
                            </Button>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    resetPasswordLinkPartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0 pb-5">
                <div className="d-none d-sm-block d-md-none d-block col-md-12 p-0">
                    <div className="row col-md-12 m-auto py-4 px-2" style={{ backgroundColor: '#39b54a' }}>
                        <div className="col-md-12 ml-5"><FaArrowLeft color="#FFFFFF" size="30" onClick={() => this.arrowIconClicked()} style={{ paddingRight: 10 }} /> <img alt="" src={BlueSkyWhiteTextLogo} width="94" height="20" /></div>
                    </div>
                </div>
                <div className="col-md-12 row py-5 m-0 my-5 d-none d-sm-block">

                </div>
                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9 pl-5 pt-3 mt-3" id="changePasswordContainer">
                        <div className="col-md-12 pb-3" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.changePasswordSetYourPswTxt}</div>
                        <div className="form-group col-md-12 pb-3">
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.changePasswordEnterPswTxt}</label>
                            <Input type="password" name="passwordInResetPasswordPart" autoComplete="new-password" className="loginCredItem input_data mandatoryFieldSpecial typePassword pt-4 pb-3"
                                placeholder={this.props.locales.changePasswordNewPswPlc} onChange={(event) => this.inputValueChange("passwordInResetPasswordPart", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.passwordInResetPasswordPart, this.props.locales.changePasswordNewPswPlc)} style={{ color: '#404042', fontWeight: 500 }} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        <div className="form-group col-md-12" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.changePasswordConfirmPswTxt}</label>
                            <Input type="password" name="confirmPasswordInResetPasswordPart" autoComplete="new-password" className="loginCredItem input_data mandatoryFieldSpecial typePassword pt-4 pb-3"
                                placeholder={this.props.locales.changePasswordComfirmPswPlc} onChange={(event) => this.inputValueChange("confirmPasswordInResetPasswordPart", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.confirmPasswordInResetPasswordPart, this.props.locales.changePasswordComfirmPswPlc)} style={{ color: '#404042', fontWeight: 500 }} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        <div className="form-group col-md-12 pt-2">
                            {this.props.locales.SettingsCompCharecterToolTip}
                        </div>
                        <div className="col-md-12 pt-4">
                            <Button className="loginPageLoginButton" onClick={() => { this.submitButtonClicked() }}>
                                {this.props.locales.changePasswordDoneBtn}
                            </Button>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        userRegisterDetails: state.userRegisterDetails,
        userDetails: state.userDetails
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setIsUserLoggedInTrue: function () {
            dispatch(setIsUserLoggedInTrue());
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload));
        },
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        }
    }
}

const resetPasswordUsingLinkPartComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(resetPasswordUsingLinkPartComponent)


export default resetPasswordUsingLinkPartComponentContainer;
